import React, {type JSX} from 'react';

const FirebasePerformanceWrapper = ({children}: {children: React.ReactNode}): JSX.Element => {
  return <>{children}</>;
};

export {FirebasePerformanceWrapper};
